import { BarChart as Chart } from '@mui/x-charts/BarChart'
import { useState } from 'react'

const BarChart = ({ data = [] }) => {
  const groupedEvents = Object.groupBy(
    data.map((d) => ({
      ...d,
      startedAt: d.startedAt.substring(0, 10)
    })),
    (x) => x.startedAt
  )

  const [visibleKeys, setVisibleKeys] = useState([
    {
      type: 'measure-communication',
      isVisible: true
    },
    {
      type: 'communication',
      isVisible: true
    },
    {
      type: 'threshold',
      isVisible: true
    },
    {
      type: 'delta',
      isVisible: true
    },
    {
      type: 'activation',
      isVisible: false
    },
    {
      type: 'measure-trigger',
      isVisible: false
    },
    {
      type: 'scheduled-trigger',
      isVisible: true
    }
  ])

  const toggleVisibleCharts = (_, item) => {
    const newVk = visibleKeys.map((vk) => ({
      ...vk,
      isVisible: vk.type === item.seriesId ? !vk.isVisible : vk.isVisible
    }))
    setVisibleKeys(newVk)
  }

  const chartData = Object.keys(groupedEvents).map((x) => {
    const measureCommunication = groupedEvents[x].find(
      (c) =>
        c.type === 'measure-communication' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    const communication = groupedEvents[x].find(
      (c) =>
        c.type === 'communication' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    const threshold = groupedEvents[x].find(
      (c) =>
        c.type === 'threshold' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    const delta = groupedEvents[x].find(
      (c) =>
        c.type === 'delta' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    const activation = groupedEvents[x].find(
      (c) =>
        c.type === 'activation' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    const measureTrigger = groupedEvents[x].find(
      (c) =>
        c.type === 'measure-trigger' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    const scheduledTrigger = groupedEvents[x].find(
      (c) =>
        c.type === 'scheduled-trigger' &&
        visibleKeys.find((x) => x.isVisible && x.type === c.type)
    )
    return {
      startedAt: x,
      measureCommunication: measureCommunication?.total || null,
      communication: communication?.total || null,
      threshold: threshold?.total || null,
      activation: activation?.total || null,
      measureTrigger: measureTrigger?.total || null,
      delta: delta?.total || null,
      scheduledTrigger: scheduledTrigger?.total || null
    }
  })

  return (
    <div style={{ height: '400px' }}>
      <Chart
        dataset={chartData}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'startedAt',
            tickLabelStyle: {
              fontSize: 12
            }
          }
        ]}
        series={visibleKeys.map((key) => ({
          dataKey: key.type,
          id: key.type,
          label: `${key.type} - ${key.isVisible ? 'Visibile' : 'Nascosto'}`,
          stack: 'total'
        }))}
        height={450}
        margin={{
          top: 50,
          right: 130,
          bottom: 90,
          left: 60
        }}
        barCategoryGap={0.3}
        slotProps={{
          legend: {
            direction: 'vertical',
            position: {
              vertical: 'middle',
              horizontal: 'center'
            },
            onItemClick: toggleVisibleCharts
          }
        }}
      />
    </div>
  )
}

export default BarChart
